<template>
  <span :class="typeClass">
    {{ transaction.amount >= 0 ? "+" : "" }}
    {{ transaction.amount | priceDisplay }}
  </span>
</template>

<script>
export default {
  name: "TransactionAmount",
  props: ["transaction"],
  computed: {
    typeClass() {
      switch (this.transaction.type) {
        case 'deposit':
        case 'refund':
          return 'text-success';
        case 'withdrawal':
        case 'payment':
          return this.transaction.amount >= 0 ? 'text-success' : 'text-danger';
        default:
          return '';
      }
    },
    prefix() {
      switch (this.transaction.type) {
        case 'deposit':
        case 'refund':
          return '+';
        case 'withdrawal':
        case 'payment':
          return '-';
        default:
          return '';
      }
    },
  },
};
</script>